/** Push a page view event to the GTM data layer.
 *
 */
export const pushPageViewEvent = (path, title) => {
    window.dataLayer.push({
        event: "pageview",
        pagePath: path,
        pageTitle: title,
    });
};
